import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DatePickerModule } from 'primeng/datepicker';
import { FloatLabelModule } from 'primeng/floatlabel';

@Component({
  selector: 'date-input-field',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, DatePickerModule, FloatLabelModule],
  templateUrl: './date-input-field.component.html',
  styleUrls: ['./date-input-field.component.scss'],
})
export class DateInputFieldComponent {
  @Input() label = '';
  @Input({ required: true }) control!: FormControl;
  @Input() errorMessage?: string;
}
